// Initial timeline displayer
// TODO: re-write using current react, not reflux, and no server-side html
// TODO: Convert to CLR-compatible
var Timeline = function(options){
    var oThis = this;
    oThis.defaults = {
        params: null,
        portfolioid: 0,
        viewerid: 0,
        canEdit: false,
        eventsMinDistance: 60

    }
    oThis.settings = $.extend( {}, oThis.defaults, options );
    oThis.settings.canEdit = oThis.settings.portfolioid == oThis.settings.viewerid;
    oThis.Actions = Reflux.createActions(['fetchData','fetchCollections']);
    oThis.createStore();

    //React components
    //Timeline
    oThis.Timeline = createReactClass({

        mixins: [Reflux.connect(oThis.TimelineStore, 'timelinestore')],

        getInitialState: function() {
            return {
                viewportWidth: document.body.clientWidth,
                present: false,
                eventview: null
            }
        },

        handleStopPresenting: function(){
            oThis.stopPresenting();
        },

        handleClickAdd: function(){
            var $component = $(ReactDOM.findDOMNode(this));

            httpGet(buildView(mantlroutes.portfolio_event_create,{ portfolioid: oThis.settings.portfolioid })).then(
                function(value) {
                    var response = value;

                    var $modal = buildModal(response,{
                        classes: 'modal modal--large',
                        header: "Create Timeline Event"
                    });
                    $('body').append($modal);
                    $modal.on("modal:close",function(){
                        $modal.off("modal:close").remove();
                        oThis.Actions.fetchData();
                    })
                    $modal.openModal({ closeOnEsc: false });
                })
            .catch(
                function(reason) {
                    alertify.error('Unable to Open Event Creator')
                });
        },

        componentDidMount: function(){
            var $component = $(ReactDOM.findDOMNode(this));
            reactFixRowsCols($component);
            $component.find('[data-popover=tooltip]').tooltip();
        },

        componentDidUpdate: function(prevProps, prevState){
            var $component = $(ReactDOM.findDOMNode(this));
            $component.find('[data-popover=tooltip]').tooltip();
            reactFixRowsCols($component);
        },

        render: function() {
            var oComponent = this;
            if(this.state.timelinestore){
                if(this.state.timelinestore.length == 0){
                    return (
                        <div>
                            <div className="container--dark">
                                <div data-container="container" className="timeline-intro">
                                    <div data-row="row">
                                        <div data-column="12">
                                            <img src={mantl.static_url + "assets/images/icon-timeline.png" } className="float--left header--icon" alt="Timeline Icon" />
                                            {(function(){
                                                if (oThis.settings.canEdit) {
                                                    return (<p className="text--xxl text--reversed"><b className="text--brights-secondary">This is your timeline.</b> <br />Life events, plus items you add to your collections are presented as a story here.</p>);
                                                } else {
                                                    return (<p className="text--xxl text--reversed"><b className="text--brights-secondary">This is their timeline.</b> <br />Life events that they've added, plus items in their <b>public</b> collections are presented as a story here.</p>);
                                                }
                                            })()}
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="timeline-empty">
                                <div data-container="container">
                                    <div className="timeline-empty-content">
                                        <div className="timeline-empty-marker"><i className="icon-file-text-o"></i></div>
                                        {(function(){
                                            if (oThis.settings.canEdit) {
                                                return (<button className="timeline-add" onClick={oComponent.handleClickAdd}><i className="icon-plus-circle"></i> Add New Event</button>);
                                            } else {
                                                return (<span className="timeline-add">Their timeline is empty</span>);
                                            }
                                        })()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                } else {
                    var eventMinLapse = oThis.minLapse(this.state.timelinestore);
                    var timelineWidth = oThis.getTimelineWidth(eventMinLapse);
                    var navWidth = document.body.clientWidth-16;
                    var events = [];
                    var nav_events = [];
                    for(var i = 0; i < this.state.timelinestore.length; i++){
                        var oItem = this.state.timelinestore[i];
                        events.push(<oThis.TimelineEvent id={oItem.id} key={oItem.id} order={i} minlapse={eventMinLapse} type={oItem.type} title={oItem.title} start={oItem.start} view_url={oItem.view_url} />);
                        nav_events.push(<oThis.TimelineNavEvent order={i} key={oItem.id} minlapse={eventMinLapse} navwidth={navWidth} timelinewidth={timelineWidth} start={oItem.start} type={oItem.type} />);
                    }

                    //Build the timeline
                    return (
                        <div>
                            <div>
                                <div id="timeline_stop" style={{"display": "none", "marginTop": "0.5em"}} className="text--left container"><button onClick={oComponent.handleStopPresenting} className="button--flat button--skinny" title="Close Event Viewer">× Close Viewer</button></div>
                                <div id="timeline_presenter" className="timeline-presenter"></div>
                            </div>

                            <div data-container="container">
                                <div data-row="row" className="timeline-header">
                                    <div data-column="6" className="text--losetop form--inline">
                                        {(function(){
                                            if (oThis.settings.canEdit) {
                                                return (<label className="timeline-collections-label" data-popover="tooltip" data-placement="top" data-original-title="This is your timeline. Life events plus collection items are presented as a story here.">My Timeline</label>);
                                            } else {
                                                return (<label className="timeline-collections-label" data-popover="tooltip" data-placement="top" data-original-title="This is their timeline. Life events that they've added, plus items in their public collections are presented as a story here.">Their Timeline</label>);
                                            }
                                        })()}
                                         <oThis.TimelineCollections />
                                    </div>
                                    <div data-column="6" className="text--losetop text--right">
                                        {(function(){
                                            if (oThis.settings.canEdit) {
                                                return (<button className="timeline-add" onClick={oComponent.handleClickAdd}><i className="icon-plus-circle"></i> Add New Event</button>);
                                            }
                                        })()}
                                    </div>
                                </div>
                            </div>

                            <section className="timeline">
                                <div className="timeline-events-wrapper">
                                    <div className="timeline-line"></div>
                                    <div className="timeline-events" style={{'width':timelineWidth}}>{events}</div>
                                </div>

                                <div className="timeline-nav-wrapper">
                                    <div className="timeline-nav dragdealer" id="timeline-nav">
                                        <oThis.TimelineNavSlider navwidth={navWidth} timelinewidth={timelineWidth} />
                                        {nav_events}
                                    </div>
                                </div>
                            </section>

                        </div>
                    );
                }

            } else {
                return (
                    <div><div className="spinner spinner--pulsing"><div className="spinner-ring"></div></div></div>
                );
            }

        }
    });

    oThis.TimelineEvent = createReactClass({
        componentDidMount: function() {
            var $component = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
            $component.tooltip();

            var eventDate = new Date(this.props.start);
            var distance = oThis.dayDiff(new Date(oThis.TimelineStore.events[0].start), eventDate);
            var distanceNorm = Math.round(distance/this.props.minlapse) + 2;
            var left = distanceNorm * oThis.settings.eventsMinDistance;

            if(this.props.order > 0){
                var prevDate = new Date(oThis.TimelineStore.events[this.props.order - 1].start);
                var spacer = oThis.settings.eventsMinDistance/(24*60);
                if(prevDate.toDateString() == eventDate.toDateString()){
                    //on same day, need to offset slightly
                    left += parseInt(((eventDate.getHours()*60) + eventDate.getMinutes()) * spacer);
                }
            }

            $component.css('left', left + 'px');
        },

        componentDidUpdate: function() {
            var $component = $(ReactDOM.findDOMNode(this));
        },

        handleClick: function(e){
            e.preventDefault();
            var oComponent = this;
            oThis.presentEvent(this.props.order);
        },

        render: function() {
            var oComponent = this;
            var eventClasses = "timeline-event timeline-event--" + this.props.type.toLowerCase();
            var iconClasses = "icon-map-marker";
            switch(this.props.type.toLowerCase()){
                case "work":
                    iconClasses = "icon-file-text-o";
                    break;
                case "endorsement":
                    iconClasses = "icon-thumbs-up";
                    break;
                case "badge":
                    iconClasses = "icon-certificate";
                    break;
                case "education":
                    iconClasses = "icon-graduation-cap";
                    break;
                case "employment":
                    iconClasses = "icon-id-badge";
                    break;
                case "volunteer":
                    iconClasses = "icon-handshake-o";
                    break;
                case "award":
                    iconClasses = "icon-trophy";
                    break;
                case "publication":
                        iconClasses = "icon-book";
                        break;
            }

            iconClasses += " icon--reversed";
            //we can't just use css nth-child because tooltips change it on the fly
            if(isOdd( parseInt(this.props.order) )){
                eventClasses += " timeline-event--above";
            } else {
                eventClasses += " timeline-event--below";
            }


            return (
                <a href={this.props.view_url} onClick={this.handleClick} data-order={this.props.order} data-date={this.props.start} className={eventClasses} data-popover="tooltip" data-placement="top" data-original-title={this.props.type + ": " + this.props.title}><i className={iconClasses}><span className="screenreader">{this.props.type + ": " + this.props.title}</span></i></a>
            );

        }
    });

    oThis.TimelineNavEvent = createReactClass({
        componentDidMount: function() {
            var $component = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
            $('[data-popover="tooltip"]',$component).tooltip();

            var distance = oThis.dayDiff(new Date(oThis.TimelineStore.events[0].start), new Date(this.props.start));
            var distanceNorm = Math.round(distance/this.props.minlapse) + 2;
            var timelineNavRatio = (this.props.navwidth - 8)/this.props.timelinewidth;
            var left = distanceNorm * oThis.settings.eventsMinDistance * timelineNavRatio;
            $component.css('left', left + 'px');
        },

        componentDidUpdate: function() {
        },

        render: function() {
            var oComponent = this;
            var eventClasses = "timeline-nav-event timeline-event--" + this.props.type.toLowerCase();
            return (
                <div className={eventClasses}></div>
            );

        }
    });

    oThis.TimelineNavSlider = createReactClass({
        componentDidMount: function() {
            var $component = $(ReactDOM.findDOMNode(this));
            var oComponent = this;

            var viewportWidth = document.body.clientWidth;
            var timelineNavRatio = this.props.navwidth/this.props.timelinewidth;
            var navSliderWidth = this.props.navwidth * timelineNavRatio;

            if(navSliderWidth > viewportWidth){
                navSliderWidth = viewportWidth - 16;
                //sorry future self for magic number (width of two yellow end pieces)
            }

            $component.width(navSliderWidth);

            new Dragdealer('timeline-nav', {
                animationCallback: function(x, y) {
                    $(".timeline-events").css('transform','translateX(-' + (x * (oComponent.props.timelinewidth - document.body.clientWidth)) + 'px)');
                }
            });
        },

        componentDidUpdate: function() {
            var $component = $(ReactDOM.findDOMNode(this));
        },

        render: function() {
            var oComponent = this;
            return (
                <div className="timeline-nav-slider handle"></div>
            );

        }
    });

    //Collections list
    oThis.TimelineCollections = createReactClass({
        mixins: [Reflux.connect(oThis.CollectionStore, 'collectionstore')],

        componentDidMount: function() {
            var $component = $(ReactDOM.findDOMNode(this));
            var oComponent = this;

            $('body').on('change','.timeline-collections',function(){
                if($(this).val() != "0"){
                    oThis.settings.params = { "collection": $(this).val() };
                    oThis.Actions.fetchData();
                } else {
                    oThis.settings.params = null;
                    oThis.Actions.fetchData();
                }
                $("#timeline_presenter").empty();
            });
        },

        componentDidUpdate: function() {
        },

        render: function() {
            var oComponent = this;
            if(this.state.collectionstore && this.state.collectionstore.length > 0){
                var options = [];
                this.state.collectionstore.forEach(function(element,index){
                    if(!element.private || oThis.settings.canEdit){
                        options.push(<oThis.TimelineCollectionOption id={element.id} key={element.id} title={element.title} private={element.private} />);
                    }
                });

                if(options.length > 0){
                    return (
                        <select id="collections" className="timeline-collections">
                            <option value="0">All Collections</option>
                            {options}
                        </select>
                    );
                } else {
                    return (
                        <select id="collections" className="timeline-collections">
                            <option value="0">Life Events Only (No Collections are Public)</option>
                        </select>
                    );
                }

            } else {
                return (
                    <div></div>
                );
            }


        }
    });

    oThis.TimelineCollectionOption = createReactClass({
        render: function() {
            var oComponent = this;
            return (
                <option data-private={this.props.private} value={this.props.id}>{this.props.title}</option>
            );
        }
    });

};

Timeline.prototype.stopPresenting = function(){
    // TODO all of this is terrible, start using state and update render. Remove server side HTML returns.
    $("#timeline_stop").hide();
    $("#timeline_next").hide();
    $("#timeline_previous").hide();
    $("#timeline_presenter").empty();
};

Timeline.prototype.presentEvent = function(order){
    var order = parseInt(order);
    oThis = this;
    var $thisEvent = $('.timeline-event[data-order=' + order + ']');
    $("#timeline_stop").show();
    httpGet($thisEvent.attr('href')).then(
        function(value) {
            var response = value;
            $("#timeline_presenter").html(response);

            var $prevEvent = $('.timeline-event[data-order=' + (order-1) + ']');
            var $nextEvent = $('.timeline-event[data-order=' + (order+1) + ']');

            if($prevEvent.length > 0){
                $("#timeline_previous").show().click(function(){
                    oThis.presentEvent($prevEvent.attr('data-order'));
                });
            } else {
                $("#timeline_previous").hide();
            }
            if($nextEvent.length > 0){
                $("#timeline_next").show().click(function(){
                    oThis.presentEvent($nextEvent.attr('data-order'));
                });
            } else {
                $("#timeline_next").hide();
            }
            $("#timeline_presenter").focus();
        })
    .catch(
        function(reason) {
            alertify.error('Unable to Open Timeline Event')
        });
};

Timeline.prototype.minLapse = function(events){
    var oThis = this;
    //determine the minimum distance among events
    var dateDistances = [1];
    for (i = 1; i < events.length; i++) {
        var distance = oThis.dayDiff(new Date(events[i-1].start), new Date(events[i].start));
        if(distance > 0){ //no divide by 0
            dateDistances.push(distance);
        }
    }

    return Math.min.apply(null, dateDistances);
};

Timeline.prototype.getTimelineWidth = function(eventsMinLapse){
    var oThis = this;
    var day1 = new Date( oThis.TimelineStore.events[0].start );
    var day2 = new Date( oThis.TimelineStore.events[oThis.TimelineStore.events.length-1].start );
    oThis.TimelineStore.events[oThis.TimelineStore.events.length-1];
    var timeSpan = oThis.dayDiff(day1, day2);
    var timeSpanNorm = timeSpan/eventsMinLapse,
        timeSpanNorm = Math.round(timeSpanNorm) + 4,
        totalWidth = timeSpanNorm * oThis.settings.eventsMinDistance;
    return totalWidth;
}

Timeline.prototype.dayDiff = function(first, second){
    var timeDiff = Math.abs(first - second);
    var ms_per_day = 1000 * 60 * 60 * 24;
    var dayDiff = Math.floor(timeDiff / ms_per_day);
    return dayDiff;
}

Timeline.prototype.weekDiff = function(first, second){
    var timeDiff = Math.abs(first - second);
    var ms_per = 1000 * 60 * 60 * 24 * 7;
    var weekDiff = Math.floor(timeDiff / ms_per);
    return weekDiff;
}


Timeline.prototype.render = function(containerID) {
    var oThis = this;
    oThis.settings.containerID = containerID;
    ReactDOM.render(<this.Timeline />, document.getElementById(oThis.settings.containerID));
}

//REFLUX STORE
Timeline.prototype.createStore = function() {
    var oThis = this;

    oThis.TimelineStore = Reflux.createStore({
        listenables: oThis.Actions,
        events: [],
        init: function() {
            //this.onX();
        },

        getInitialState: function() {
            this.onFetchData();
        },

        onFetchData: function() {
            var oStore = this;
            var endpoint = buildRoute(mantlroutes.portfolio_timeline,{ portfolioid: oThis.settings.portfolioid });
            if(oThis.settings.params != null){
                endpoint += formatParams(oThis.settings.params);
            }
            httpGet(endpoint).then(
                function(value) {
                    var response = JSON.parse(value);
                    oStore.events = response;
                    oStore.trigger(oStore.events);
                })
            .catch(
                function(reason) {
                    alertify.error('Unable to Load Timeline');
                });

        }

    });

    oThis.CollectionStore = Reflux.createStore({
        listenables: oThis.Actions,
        collections: [],
        init: function() {
            //this.onX();
        },

        getInitialState: function() {
            this.onFetchCollections();
        },

        onFetchCollections: function() {
            var oStore = this;
            var endpoint = buildRoute(mantlroutes.portfolio_collections,{ portfolioid: oThis.settings.portfolioid });
            httpGet(endpoint).then(
                function(value) {
                    var response = JSON.parse(value);
                    oStore.collections = response;
                    oStore.trigger(oStore.collections);
                })
            .catch(
                function(reason) {
                    alertify.error('Unable to Load Collections');
                });

        }

    });

}
